<template>
  <div class="main print-no-padding drugsManagement">
    <h2 class="is-print-hide title-area">
      <div class="title">
        <span class="main-title">药品管理</span>
        <span class="sub-title">仅展示自行添加的药品信息</span>
      </div>
      <div class="handle-bar">
        <el-button class="btn" @click="handleExcelExport">导出药品</el-button>
        <el-button class="btn" @click="handleExcelModal">批量导入药品</el-button>
        <el-button class="btn" @click="$router.push('/drugsManagement/add')">添加药品</el-button>
      </div>
    </h2>
    <el-card>
      <searchBar :search-params="searchParams" @change="change" @search="search" />
      <drugsManagementTable
        :page-no="searchParams.pageNo"
        :page-size="searchParams.pageSize"
        :data="data"
        :total="total"
        @handle-pageNo="handlePageNo"
        @handle-pageSize="handlePageSize"
        @refresh="init"
      />
    </el-card>
    <uploadExcel :visible="visible" @close="handleExcelModal" @refresh="search" />
  </div>
</template>

<script>
import Fetch from '@/api';
import searchBar from './components/searchBar';
import drugsManagementTable from './components/drugsManagementTable';
import uploadExcel from './components/uploadExcel';
import {MessageBox} from "element-ui";
import router from "../../router";

export default {
  name: 'drugsManagement',
  components: {
    searchBar,
    drugsManagementTable,
    uploadExcel
  },
  data() {
    return {
      visible: false,
      searchParams: {
        name: '',
        barcode: '',
        pageNo: 1,
        pageSize: 10
      },
      data: [],
      total: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    handleExcelModal() {
      this.visible = !this.visible;
    },
    change(key, val) {
      this.searchParams[key] = val;
    },
    fetchDrugPage(params) {
      return Fetch.query_company_drug_page(params).then(({ data, pageNo, pageSize, totalCount }) => {
        this.data = data;
        this.total = totalCount;
        this.searchParams.pageNo = pageNo;
        this.searchParams.pageSize = pageSize;
      });
    },
    init() {
      // 获取药店是否支持商品编码及导入模板地址
      this.$store.dispatch('drugsManagement/FetchDrugSetting');

      return this.fetchDrugPage(this.searchParams);
    },
    search() {
      const { name, barcode } = this.searchParams;
      return this.fetchDrugPage({ name, barcode, pageNo: 1, pageSize: 10 });
    },
    handlePageNo(pageNo) {
      const { name, barcode, pageSize } = this.searchParams;
      return this.fetchDrugPage({ name, barcode, pageNo, pageSize });
    },
    handlePageSize(pageSize) {
      const { name, barcode, pageNo } = this.searchParams;
      return this.fetchDrugPage({ name, barcode, pageNo, pageSize });
    },
    handleExcelExport() {
      const { name, barcode } = this.searchParams;
      Fetch.exportDrugByExcel( { name, barcode }).then(res => {
        MessageBox.confirm('文件正在生成中，请前往下载中心进行下载', '数据导出成功', {
          center: true,
          confirmButtonText: '前往下载中心下载',
          cancelButtonText: '稍后下载',
          beforeClose(action, instance, done) {
            switch (action) {
              case 'confirm':
                done();
                router.push('/download');
                break;
              case 'cancel':
              case 'close':
                done();
                break;
            }
          }
        });
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.drugsManagement {
  .title-area {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    .sub-title {
      margin-left: 8px;
      font-size: 12px;
      color: #bdbdbd;
    }

    .handle-bar {
      .btn {
        width: 132px;
        color: #ebb436;
        border: 1px solid #ebb436;
      }
    }
  }
}
</style>
